import React, { Component } from 'react';
import { Table, Button, Pagination, notification, Input, Form, Select  } from 'antd';
import { AppstoreAddOutlined, SearchOutlined } from '@ant-design/icons'
import CreateNewIssue from './CreateNewIssue';
import EditDetailInformation from './EditDetailInformation'
import { post } from '../../utils/http';
import api from '../../utils/api';
import { sessionManager } from '../../core/SessionManager';
import moment from 'moment';

class Servicing extends Component {

  constructor(props) {
    super(props);
    this.state = {
      total: 0,
      data: [],
      current: 1,
      pageSize: 10,
      searchStatus: "",
      searchName: "",
      isOpenCreate: false,
      isOpenEdit: false,
      issueIdNow: -1,
      loading: false,
      roleId: sessionManager.getUserRole()
    }
  }

  columns = [
    {
      title: 'Service Id',
      key: 'issueid',
      dataIndex: 'issueid',
    },
    {
      title: 'Service Category',
      key: 'servicecategory',
      dataIndex: 'servicecategory',
    }, {
      title: 'Service Type',
      key: 'servicetype',
      dataIndex: 'servicetype',
    }, {
      title: 'Reported By',
      key: 'reportedby',
      dataIndex: 'reportedby',
    }, {
      title: 'Last Updated',
      width: 260,
      key: 'lastupdated',
      dataIndex: 'lastupdated',
      render: text => {
        return this.handleDateTime(text);
      }
    }, {
      title: 'Status',
      key: 'status',
      dataIndex: 'status'
    }, {
      align: 'center',
      title: 'Action',
      key: 'Action',
      fixed: 'right',
      render: (_, record) => {
        return (
          <div style={{ display: 'flex', width:60, marginLeft:'auto', marginTop:0, marginRight:'auto', marginBottom:0 }}>
            <Button type='primary' shape="round" style={{ marginRight: '10px' }} onClick={() => this.openEditModal(record.issueid)} >View</Button>
          </div>
        )
      }
    },
  ];

  handleChangePage = (current, pageSize) => {
    this.setState({ current: current, pageSize: pageSize, loading: true }, () => {
      this.handleSearch(false)
    })
  }

  openCreateModal = () => {
    this.setState({ isOpenCreate: true })
  }

  closeCreateModal = () => {
    this.setState({ isOpenCreate: false })
  }

  openEditModal = (record) => {
    this.setState({ isOpenEdit: true, issueIdNow: record })
  }

  closeEditModal = () => {
    this.setState({ isOpenEdit: false })
  }

  handleChangeSelect = (value) => {
    this.setState({ searchStatus: value })
  };

  handleChangeInput = (event) => {
    this.setState({ searchName: event.target.value })
  };

  handleDateTime = (text) => {
    var date = Date.parse(text);
    var strDate = new Date(date);
    strDate.setHours(strDate.getHours() + new Date().getTimezoneOffset() / -60);
    return moment(strDate).format('YYYY-MM-DD HH:mm:ss');
  }

  handleSearch = (flag) => {
    this.setState({ loading: true });
    let { searchName, searchStatus, pageSize, current, roleId } = this.state;
    let searchData;
    if (flag) {
      searchData = {
        status: searchStatus,
        searchName: searchName,
        pageNum: 1,
        pageSize: pageSize,
        merchantId: sessionManager.getMerchantId()
      }
    } else {
      searchData = {
        status: searchStatus,
        searchName: searchName,
        pageNum: current,
        pageSize: pageSize,
        merchantId: sessionManager.getMerchantId()
      }
    }

    var _this = this

    post(api.queryReqList, searchData).then(function (response) {
      var { total, currentPage, pageSize, rows } = response
      _this.setState({
        current: currentPage,
        pageSize: pageSize,
        total: total,
        data: rows,
        loading: false
      })
    }).catch(function (error) {
      notification['error']({
        message: 'Fail to search.',
      });
      console.log("@error", error)
      _this.setState({
        loading: false
      })
    })
  }

  componentWillMount() {
    this.handleSearch(true)
  }

  render() {
    const { data, current, total, loading } = this.state;
    return (
      <div>
        <div style={{ backgroundColor: "white", display: "flex", justifyContent: "space-between", marginBottom: "10px", padding: "20px" }}>
          <Form
            layout="inline"
          >
            <Form.Item label="Status">
              <Select style={{ width: '150px' }} onChange={this.handleChangeSelect} >
                <Select.Option value=""></Select.Option>
                <Select.Option value="OPEN">OPEN</Select.Option>
                <Select.Option value="PENDING">PENDING</Select.Option>
                <Select.Option value="CLOSE">CLOSE</Select.Option>
              </Select>
            </Form.Item>
            {(this.state.roleId === '2') &&
              <Form.Item label="Username">
                <Input style={{ width: '150px' }} onChange={this.handleChangeInput} />
              </Form.Item>
            }
            <Form.Item>
              <Button icon={<SearchOutlined />} type="primary" onClick={() => this.handleSearch(true)} >Search</Button>
            </Form.Item>
          </Form>
          {this.state.roleId !=2 && <Button icon={<AppstoreAddOutlined />} type="primary" size="large" onClick={this.openCreateModal}> New Issue</Button>}
        </div>
        <Table
          scrollToFirstRowOnChange={true}
          scroll={{ x: '100%', y: 360 }}
          columns={this.columns}
          rowKey={record => record.issueid}
          dataSource={data}
          pagination={false}
          loading={loading} />
        <Pagination style={{ marginTop: '5px' }} current={current} showSizeChanger={true} total={total} onChange={this.handleChangePage} />

        {this.state.isOpenCreate  && <CreateNewIssue isOpenCreate={this.state.isOpenCreate} closeCreateModal={this.closeCreateModal} handleSearch={this.handleSearch} />}
        {this.state.isOpenEdit && <EditDetailInformation isOpenEdit={this.state.isOpenEdit} roleId={this.state.roleId} closeEditModal={this.closeEditModal} handleSearch={this.handleSearch} editValue={this.state.issueIdNow} />}
      </div>
    )
  }
}

export default Servicing;
